/* eslint-disable no-useless-constructor */
/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import StepWizard from 'react-step-wizard';
import classNames from 'classnames';
import ReactGA from 'react-ga';
import { OnboardingStepRedesign } from './OnboardingStepRedesign';
import { OnboardingProjectFormStep } from './OnboardingProjectFormStep';
import { OnboardingCongratulationsStep } from './OnboardingCongratulationsStep';
import { OnboardingHeader } from './OnboardingHeader';
import {
  unselectAllCardsInStep,
  saveFormInfo,
  resetWizard,
} from '../../store/actions/OnboardingRedesign';
import { createAccount } from '../../store/actions/Authentication';
import {
  createNewProject,
  saveProgress,
  selectProject,
} from '../../store/actions/Dashboard';
import { routes, routesAction } from '../../shared/helpers';
import './OnboardingRedesign.css';
import { getProject } from '../../store/actions/ProjectView';
import next from './next.svg';
import {
  checkNewNotifications,
  getNotifications,
  setNotificationsThreadInterval,
  dispatchCheckNewNotifications,
  dispatchCheckNotificationsInterval,
} from '../../store/actions/Notification';

class OnboardingRedesign extends Component {
  constructor(props) {
    super(props);

    this.state = { existingUser: false };

    this.setStepWizardInstance = this.setStepWizardInstance.bind(this);
    this.skipStep = this.skipStep.bind(this);
    this.updateFormInfo = this.updateFormInfo.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.checkNotifications = this.checkNotifications.bind(this);
  }

  skipStep(step) {
    this.props.dispatchUnselectAllCardsInStep(step);
    this.state.stepWizard.nextStep();
  }

  checkNotifications() {
    const {
      dispatchCheckNewNotifications,
      dispatchCheckNotificationsInterval,
    } = this.props;

    const interval = setInterval(dispatchCheckNewNotifications, 5000);

    dispatchCheckNotificationsInterval(interval);
  }

  setStepWizardInstance(stepWizard) {
    this.setState({ ...this.state, stepWizard });
  }

  submitForm({
    firstName,
    lastName,
    email,
    phoneNumber,
    country,
    dialCode,
    projectName,
    comments,
  }) {
    const { isLogin, currentUser, nextStep } = this.props;
    const accountData = {
      email: email || currentUser.email,
      country,
      name: `${firstName} ${lastName}`,
      phone_number: phoneNumber,
      phone_number_ddi: dialCode,
      type: 'Client',
    };
    const answeredQuestions = this.props.wizardInfo.map(
      ({ key, questionResponse }) => ({
        key,
        question_response: questionResponse,
      }),
    );
    const projectData = {
      project_name: projectName,
      comment: comments,
      answered_questions: answeredQuestions,
      phone_number: phoneNumber,
      email,
      status: 'pending',
    };

    this.props.dispatchUpdateFormInfo({ email });
    if (isLogin) {
      this.setState({ existingUser: true });
      this.props.dispatchCreateProject({
        email: currentUser.email,
        projectData,
        history: this.props.history,
      });
    } else {
      this.props.dispatchCreateAccount({
        accountData,
        projectData,
        checkNotificationsHandler: this.checkNotifications,
        nextStep: this.state.stepWizard.nextStep,
      });
    }
  }

  updateFormInfo(event) {
    const value = { [event.target.name]: event.target.value };
    this.props.dispatchUpdateFormInfo(value);
  }

  render() {
    const { wizardInfo, formInfo, isLogin, currentUser } = this.props;

    const noTransitions = {
      enterRight: '',
      enterLeft: '',
      exitRight: '',
      exitLeft: '',
    };

    return (
      <div>
        {!isLogin && <OnboardingHeader />}
        <StepWizard
          instance={this.setStepWizardInstance}
          transitions={noTransitions}
          className={isLogin ? 'wizzard-container' : ''}
        >
          <Step
            data={wizardInfo[0]}
            step={0}
            onSkip={this.skipStep}
            currentUser={currentUser}
            isLogin={isLogin}
          />
          <Step
            data={wizardInfo[1]}
            step={1}
            onSkip={this.skipStep}
            disabledNext={this.state.disableNext}
            updateDisableNext={this.updateDisableNext}
            currentUser={currentUser}
            isLogin={isLogin}
          />
          {wizardInfo[1].cardSelected.includes('animation') && (
            <Step
              data={wizardInfo[2]}
              step={2}
              onSkip={this.skipStep}
              currentUser={currentUser}
              isLogin={isLogin}
            />
          )}
          {/* <Step
            data={wizardInfo[3]}
            step={3}
            onSkip={this.skipStep}
            currentUser={currentUser}
            isLogin={isLogin}
          /> */}
          <ProjectFormStep
            data={{ name: 'Form' }}
            step={4}
            disabledNext={this.state.disableNext}
            updateFormInfo={this.updateFormInfo}
            formInfo={formInfo}
            submitForm={this.submitForm}
            currentUser={currentUser}
            isLogin={isLogin}
          />
          {!this.state.existingUser && (
            <CongratulationsStep step={5} email={formInfo.email} />
          )}
        </StepWizard>
      </div>
    );
  }
}

const handleChangeStep = (data, step) => {
  sendStepAnalyticsEvent(data);
  window.scrollTo(0, 0);
  if (step) step();
};

const sendStepAnalyticsEvent = step => {
  const event = { action: step.name };

  ReactGA.event({
    category: 'Onboarding',
    ...event,
  });
};

const Stats = ({
  data,
  currentStep,
  nextStep,
  previousStep,
  totalSteps,
  handleChangeStep,
}) => {
  const steps = totalSteps;
  const disableNext = data.cardSelected && data.cardSelected.length === 0;
  if (currentStep !== steps) {
    return (
      <React.Fragment>
        <div className="onboarding-red-bottom justify-content-between">
          {currentStep <= steps && (
            <button
              style={{
                visibility: currentStep == 1 ? 'hidden' : 'visible',
              }}
              className="btn-back"
              onClick={() => handleChangeStep(data, previousStep)}
              type="button"
            >
              <div className="text">Previous</div>
            </button>
          )}
          <div className="step-count-text align-self-center">
            Step {currentStep} of {steps - 1}
          </div>
          {currentStep === steps - 1 ? (
            <button
              className="btn-next"
              type="submit"
              onClick={() => handleChangeStep(data)}
            >
              <div className="text">Submit</div>
            </button>
          ) : (
            <button
              className={classNames('btn-next', {
                disabled: disableNext,
              })}
              onClick={() => handleChangeStep(data, nextStep)}
              disabled={disableNext}
            >
              <div className="text">Next</div>
            </button>
          )}
        </div>
        <div className="onboarding-red-bottom-mobile">
          {currentStep <= steps && (
            <div className="back-link ml-4">
              <a
                style={{
                  visibility: currentStep === 1 ? 'hidden' : 'visible',
                }}
                onClick={() => handleChangeStep(data, previousStep)}
              >
                Previous
              </a>
            </div>
          )}
          <div className="step-count-text align-self-center ml-11">
            Step {currentStep} of {steps - 1}
          </div>
          {currentStep === steps - 1 ? (
            <div className="submit-link ml-9">
              <button type="submit" onClick={() => handleChangeStep(data)}>
                Submit
              </button>
            </div>
          ) : (
            <div className="next-link ml-9">
              <a
                className={classNames({
                  disabled: disableNext,
                })}
                onClick={() => handleChangeStep(data, nextStep)}
                disabled={disableNext}
              >
                Next
                <i
                  className="icon ml-1 mt-0"
                  style={{
                    backgroundImage: `url(${next})`,
                    backgroundSize: 'auto',
                    backgroundRepeat: 'no-repeat',
                    color: '#35C6B2',
                  }}
                />
              </a>
            </div>
          )}
        </div>
      </React.Fragment>
    );
  }
  return null;
};

const Step = props => (
  <div>
    <OnboardingStepRedesign
      {...props.data}
      step={props.step}
      onSkip={props.onSkip}
      updateDisableNext={props.updateDisableNext}
      buttons={<Stats {...props} handleChangeStep={handleChangeStep} />}
    />
  </div>
);

const ProjectFormStep = props => (
  <div>
    <OnboardingProjectFormStep
      {...props.data}
      step={props.step}
      onSkip={props.onSkip}
      updateFormInfo={props.updateFormInfo}
      formInfo={props.formInfo}
      submitForm={props.submitForm}
      isLogin={props.isLogin}
      buttons={<Stats {...props} handleChangeStep={handleChangeStep} />}
    />
  </div>
);

const CongratulationsStep = props => (
  <div>
    <OnboardingCongratulationsStep
      {...props.data}
      step={props.step}
      onSkip={props.onSkip}
      updateDisableNext={props.updateDisableNext}
      email={props.email}
    />
  </div>
);

const mapStateToProps = state => ({
  wizardInfo: state.wizardFlow.wizardInfo,
  formInfo: state.wizardFlow.formInfo,
  isLogin: state.authentication.isLogin,
  currentUser: state.authentication.user,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchCheckNewNotifications: () => {
    dispatch(checkNewNotifications());
  },
  dispatchCheckNotificationsInterval: interval =>
    dispatch(setNotificationsThreadInterval(interval)),
  dispatchUnselectAllCardsInStep: step => {
    dispatch(unselectAllCardsInStep(step));
  },
  dispatchUpdateFormInfo: value => {
    dispatch(saveFormInfo(value));
  },
  dispatchCreateAccount: ({
    accountData,
    projectData,
    checkNotificationsHandler,
    nextStep,
  }) => {
    let projectId;
    dispatch(createAccount(accountData)).then(action => {
      if (action.type === 'AUTHENTICATION_SUCCESS') {
        dispatch(createNewProject(accountData.email)).then(data => {
          projectId = data.payload.project_id;
          dispatch(saveProgress(projectData, projectId))
            .then(statusAction => dispatch(statusAction))
            .then(() =>
              dispatch(getProject(projectId)).then(
                ({ payload: { project } }) => {
                  dispatch(selectProject(project.id, project));
                },
              ),
            )
            .then(() => checkNotificationsHandler())
            .then(() => ownProps.history.push(routesAction.project(projectId)))
            .then(() => dispatch(resetWizard()));
        });
      }
    });
  },
  dispatchCreateProject: ({ email, projectData, history }) => {
    let projectId;
    dispatch(createNewProject(email)).then(data => {
      projectId = data.payload.project_id;
      dispatch(saveProgress(projectData, data.payload.project_id))
        .then(statusAction => dispatch(statusAction))
        .then(() =>
          dispatch(getProject(projectId)).then(({ payload: { project } }) => {
            dispatch(selectProject(project.id, project));
          }),
        )
        .then(() => ownProps.history.push(routesAction.project(projectId)))
        .then(() => dispatch(resetWizard()));
    });
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OnboardingRedesign);



// WEBPACK FOOTER //
// ./src/containers/OnboardingRedesign/OnboardingRedesign.js